const getMembersFromRootMemberSummary = rootGroupMember => {
  var results = [];
  for (let member of rootGroupMember.members) {
    var memberResults = getMembersFromMembers(member);
    results = results.concat(memberResults);
  }
  return results;
};
const getMembersFromMembers = member => {
  var results = [];
  if (member.properties && member.properties['hidden'] == 'yes') {
    return [];
  }
  if (!member.isGroup) {
    return [member];
  }
  for (let child of member.members) {
    if (child.properties && child.properties['hidden'] == 'yes') {
      continue;
    }
    if (child.isGroup) {
      if (child.properties.hidden != 'yes') {
        results = results.concat(this.getMembersFromMembers(child));
      }
      continue;
    }
    results.push(child);
    continue;
  }
  return results;
};

export { getMembersFromRootMemberSummary };
